import getDefaultVideoMenuItems from './getDefaultVideoMenuItems';

export default ({ item, onKebabMenuItemClick, params, videoVersion }) => {
  const type = item.type || item.data?.type;
  const isVideo = type === 'video';
  const isTopic = type === 'topic';
  const isShortcut = item.metadata?.is_shortcut || item.data?.metadata?.is_shortcut;
  const isInLiveMode = params.type === 'live';
  const isOriginalVideo = isVideo && !isShortcut;

  const CONDITION_RENDER_MAPPING = {
    properties: !isShortcut,
    duplicate: isOriginalVideo,
    publish: isOriginalVideo || isTopic,
    'move-to': !isInLiveMode,
    permissions: isVideo || isTopic || isShortcut,
    'create-shortcut': isOriginalVideo && !isInLiveMode,
    'view-original': isShortcut,
    delete: true,
  };

  const menuItems = getDefaultVideoMenuItems({
    item,
    isTopic,
    onKebabMenuItemClick,
    params,
    videoVersion,
  }).filter(({ key }) => CONDITION_RENDER_MAPPING[key]);

  return menuItems;
};
